import React from 'react';

import { ActionIcon, Badge, Flex, Group, Paper, Text } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { DocumentList } from 'types';

interface DocumentCardProps {
  document: DocumentList;
  tab: string;
}

const DocumentCard = ({ document, tab }: DocumentCardProps): JSX.Element => {
  const { dateFormat } = useLocalization();

  return (
    <Paper component={Link} to={`/documents/${tab}/${document.documentId}`} radius='lg' p='md' shadow='xs'>
      <Group spacing='xl' position='apart' noWrap>
        <Flex direction='column'>
          <Text size='md' weight={600} color='kiloBlue'>
            {document.description}
          </Text>
          <Text size='sm' weight={500} color='dimmed'>
            {document.signedDate
              ? `Signed at ${dayjs(document.signedDate).format(dateFormat)}`
              : `Created at ${dayjs(document.createdAt).format(dateFormat)}`}
          </Text>
        </Flex>

        {document.signedDate ? (
          <ActionIcon radius='xl' variant='light' color='yellow' size='lg'>
            <IconDownload size='1.525rem' />
          </ActionIcon>
        ) : (
          <Badge color='red'>Requires signature</Badge>
        )}
      </Group>
    </Paper>
  );
};

export default DocumentCard;
